import React from 'react';
import Modal from 'react-modal';
import Row from '../../../components/tag/Row';
import OTButtonGroup from '../../../components/tag/OTButtonGroup';
import OTButton from '../../../components/tag/OTButton';
import modal from '../../../definitions/Modal';
import { FormattedMessage } from 'react-intl';
import OTLinkButton from '../../tag/OTLinkButton';

const notificationModal = modal({
  content: { width: '500px', padding: '40px 40px 30px 40px' },
});

const TaysPolkuRedirectModal = (props) => {
  const { showModal, setShowModal, redirectLink } = props;

  return (
    <Modal isOpen={showModal} style={notificationModal}>
      <Row>
        <p>
          <FormattedMessage id="tayspolku.confirm.navigation" />
        </p>
      </Row>
      <Row>
        <OTButtonGroup type="big" fullWidth={true}>
          <OTButton key="cancel" onClick={() => setShowModal(false)}>
            <FormattedMessage id="cancel" />
          </OTButton>
          <OTLinkButton key="submit" link={redirectLink} target={'_blank'}>
            <FormattedMessage id="continue" />
          </OTLinkButton>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default TaysPolkuRedirectModal;
